import React from 'react';
import TextField from '@mui/material/TextField';

export default function MyTextField(props) {
    return (
        <TextField {...props} />
    );
}